<template>
  <v-app
    id="dashboard-view">
    <!--    <core-filter />-->

    <core-toolbar />

    <core-drawer />

    <v-content id="test">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-content>

    <core-footer v-if="$route.meta.name !== 'Maps'" />

  </v-app>
</template>

<script>
export default {
  name: 'DashboardView',
  metaInfo () {
    return {
      title: 'OIS Web Admin'
    }
  },
  beforeCreate () {
    // this.$store.dispatch('reloadPermissions')
    this.$store.dispatch('autoRefreshToken') // invoked whenever refresh page/component createdn (new tab do this)
  }
}
</script>

<style>
  #dashboard-view {
    background-color: #eeeeee;
  }

  /* for v-data-table expand*/
  table > tbody > tr.expandable {
    cursor: pointer;
  }

</style>
